import { render } from "./ComplementsCapillairesFemme.vue?vue&type=template&id=19bb6a86&scoped=true"
import script from "./ComplementsCapillairesFemme.vue?vue&type=script&lang=js"
export * from "./ComplementsCapillairesFemme.vue?vue&type=script&lang=js"

import "./ComplementsCapillairesFemme.vue?vue&type=style&index=0&id=19bb6a86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bb6a86"]])

export default __exports__